export default __webpack_public_path__ + "static/media/addition.0dc95983.svg";